import { toDate } from 'date-fns-tz/toDate';

import { format as fnsFormat, getZonedDate, ZonedDate } from '@eika-infrastruktur/date';

export const datePattern = 'dd.MM.yyyy';

export const isTimeZoneDifferent = (): boolean => {
    const pattern = 'dd.MM.yyyy hh:mm';
    const clientDate = new Date();
    const zonedDate = getZonedDate();
    const textZonedDate = fnsFormat(zonedDate, pattern);
    const textClientDate = fnsFormat(clientDate, pattern);
    return textZonedDate !== textClientDate;
};

export const clonedZonedDateToDate = (zonedDate?: ZonedDate): Date => {
    return toDate(zonedDate as Date);
};

export const getWarningMessage = (
    notification: {
        selectedDay?: { id: string; text: string }[];
        selectedDate?: { id: string; text: string }[];
        timezoneDifferentMessage?: string;
    },
    selected?: Date,
): string => {
    if (selected && notification.selectedDay instanceof Array) {
        const found = notification.selectedDay.find((note) => note.id === `${selected.getDay()}`);
        if (found) {
            return found.text;
        }
    }

    if (selected && notification.selectedDate instanceof Array) {
        const found = notification.selectedDate.find((note) => {
            const selectedList = fnsFormat(selected, datePattern).split('.');
            const noteDateList = `${note.id}`.split('.');

            if (!noteDateList[2]) {
                selectedList.pop();
            }
            if (!noteDateList[1]) {
                selectedList.pop();
            }

            return noteDateList.join('.') === selectedList.join('.');
        });
        if (found) {
            return found.text;
        }
    }

    const zoneDifferent = isTimeZoneDifferent();
    return zoneDifferent ? notification.timezoneDifferentMessage ?? '' : '';
};
